/**
 * App root component.
 *
 * Composes the provider hierarchy and the application router.
 * Providers are ordered from outermost to innermost:
 *   ThemeProvider → AuthProvider → ToastProvider → AppRouter
 *
 * Background jobs (email retry, health checks, cleanup) start
 * on mount and stop on unmount.
 */

import { useEffect } from 'react';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { ToastProvider } from '@/components/ui';
import { AuthProvider } from '@/context/auth';
import { AppRouter } from '@/app/AppRouter';
import { startBackgroundJobs, stopBackgroundJobs } from '@/lib/backgroundJobs';

export default function App(): JSX.Element {
  useEffect(() => {
    startBackgroundJobs();
    return () => stopBackgroundJobs();
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <AppRouter />
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
